import { render, staticRenderFns } from "./BrandIntro.vue?vue&type=template&id=b4b8411c&scoped=true&"
import script from "./BrandIntro.vue?vue&type=script&lang=js&"
export * from "./BrandIntro.vue?vue&type=script&lang=js&"
import style0 from "./BrandIntro.vue?vue&type=style&index=0&id=b4b8411c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b8411c",
  null
  
)

export default component.exports